import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore/lite";

const firebaseConfig = {
  apiKey: "AIzaSyAIBvdMxHZn8XxMrc2s8EXkeL6oqD6259E",
  authDomain: "meal-menu-7437b.firebaseapp.com",
  projectId: "meal-menu-7437b",
  storageBucket: "meal-menu-7437b.firebasestorage.app",
  messagingSenderId: "909935472851",
  appId: "1:909935472851:web:b6dcb918741872e757e426",
  measurementId: "G-FW9J80T1X5",
};

const app = initializeApp(firebaseConfig);
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LcakkotAAAAAFvCnrvJfadUYahPHWbkjORY4zCn"),
  isTokenAutoRefreshEnabled: true,
});
const db = getFirestore(app);

const TODAY_KEY = "mm2-today";
const HIST_KEY = "mm2-hist";

export async function sGet(key) {
  try {
    if (key === TODAY_KEY) { var snap = await getDoc(doc(db, "today", "selections")); return snap.exists() ? snap.data().value : null; }
    if (key === HIST_KEY) { var snap2 = await getDoc(doc(db, "history", "all")); return snap2.exists() ? snap2.data().value : null; }
    var snap3 = await getDoc(doc(db, "config", key)); return snap3.exists() ? snap3.data().value : null;
  } catch (e) { console.error("sGet error:", key, e); return null; }
}

export async function sSet(key, value) {
  try {
    if (key === TODAY_KEY) { await setDoc(doc(db, "today", "selections"), { value: value }); return; }
    if (key === HIST_KEY) { await setDoc(doc(db, "history", "all"), { value: value }); return; }
    await setDoc(doc(db, "config", key), { value: value });
  } catch (e) { console.error("sSet failed", key, e); throw e; }
}
